export default __webpack_public_path__ + "static/media/phone2.35a1c265.png";